<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            groupList: sortedGroups$ | async,
            values: values.$ | async,
            optionClass: multiple || forceCheckbox ? 'bazis-checkbox' : 'bazis-radio',
            disabled: disabled.$ | async,
        } as data"
    >
        <div
            *ngIf="ngControl.control; let control"
            [class]="'bazis-control ' + cssClassSizeControl"
            [ngClass]="{
                'bazis-control--invalid': ngControl.control.invalid,
                'bazis-control--disabled': data.disabled,
                'bazis-control--dirty': ngControl.control.dirty,
                'bazis-control--empty':
                    emptyValues.indexOf(ngControl.control.value) > -1 ||
                    (multiple && !ngControl.control.value?.length),
            }"
        >
            <bazis-label
                [isMajor]="hasTitleMajor"
                [isEmptyLabel]="isEmptyLabel"
                [title]="title || t(titleKey, titleParams)"
                [required]="data.required"
            >
                <bazis-interrogation
                    *ngIf="tooltipKey"
                    [slot]="tooltipSettings?.targetSide"
                    iconSize="compact"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipOffset]="[-8, 4]"
                    [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                    [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                    [icon]="icons.interrogation"
                    [type]="interrogationType"
                ></bazis-interrogation>
            </bazis-label>

            <div class="bazis-list">
                <div
                    *ngFor="let group of data.groupList; let i = index"
                    [ngClass]="[
                        data.optionClass,
                        direction === 'right' ? data.optionClass + '_right' : '',
                    ]"
                    [class.bh-inline-block]="isOneline"
                    class="bazis-item bazis-item_group"
                    (click)="toggleGroup(i)"
                >
                    <span *ngIf="group.groupEntity as groupEntity">
                        {{ groupEntity.$snapshot.name }}
                        <bazis-icon
                            size="regular"
                            [name]="showGroup[i] ? icons.angleUp : icons.angleDown"
                        ></bazis-icon>
                    </span>
                    <div
                        [hidden]="!showGroup[i]"
                        class="bazis-list"
                    >
                        <ng-container *ngFor="let option of group.groupOptions">
                            <label
                                class="bazis-item"
                                [class.bazis-checkbox]="multiple"
                                [class.bazis-radio]="!multiple"
                                (click)="toggleValueInGroup(option.id, $event)"
                            >
                                <input
                                    [type]="multiple || forceCheckbox ? 'checkbox' : 'radio'"
                                    [disabled]="data.disabled"
                                    [checked]="data.values.indexOf(option.id) > -1"
                                    (change)="preventDefault($event)"
                                    (click)="preventDefault($event)"
                                />
                                <span
                                    [ngClass]="[
                                        data.optionClass + '__label',
                                        hasLabelMajor ? 'bh-font-medium' : '',
                                        option.$snapshot.name ? '' : 'bazis-label-hidden',
                                    ]"
                                >
                                    {{ option.$snapshot.name }}
                                </span>
                            </label>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- <ng-container *ngIf="tooltipKey">
                <bazis-interrogation
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                    [tooltipPlacement]="tooltipSettings?.placement || 'bottom-start'"
                    [tooltipIsStatic]="false"
                [icon]="icons.interrogation"
            [type]="interrogationType"
                ></bazis-interrogation>
            </ng-container> -->
        </div>
    </ng-container>
</ng-container>
